import { HOURS, HOURS_NOTE } from "../lib/site";

// Tableau des horaires d'ouverture
export const HoursTable = ({ tone = "light", testId = "hours-table" }) => {
  const isDark = tone === "dark";
  const rowBorder = isDark ? "border-white/10" : "border-crustborder";
  const dayColor = isDark ? "text-cream" : "text-charcoal";
  const valColor = isDark ? "text-white/70" : "text-ash";
  const closedColor = isDark ? "text-white/40" : "text-ash/70";
  const noteColor = isDark ? "text-white/45" : "text-ash";

  return (
    <div data-testid={testId}>
      <dl className="w-full">
        {HOURS.map((h) => (
          <div
            key={h.day}
            className={`flex items-baseline justify-between border-b ${rowBorder} py-3`}
          >
            <dt className={`font-serif text-lg ${dayColor}`}>{h.day}</dt>
            <dd
              className={`text-sm tabular-nums ${
                h.closed ? closedColor : valColor
              }`}
            >
              {h.value}
            </dd>
          </div>
        ))}
      </dl>
      <p className={`mt-4 text-xs leading-relaxed ${noteColor}`}>{HOURS_NOTE}</p>
    </div>
  );
};
